import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "message-base" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  class: "msg-list",
  id: "chat_home_main"
}
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "input-bar" }

import ChatInputBar from "@/components/Dialogues/Chat/ChatInputBar.vue";
import MsgMine from "@/views/ChatMessage/MsgMine.vue";
import MsgReply from "@/views/ChatMessage/MsgReply.vue";
import {
  chatList,
  chatStatus,
  stopAbort,
} from "@/views/Home/useData/module/chat";
import {
  pcChatScrollMixins,
  pcInitScrollParams,
  pcScrollStatus,
} from "@/views/Home/useData/module/chatScroll";

import { watch, computed, onMounted, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  setup(__props) {

watch(
  chatList,
  () => {
    // console.log("chatList", chatList);
  },
  {
    immediate: true,
    deep: true,
  }
);

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

onMounted(() => {
  pcInitScrollParams();
  const first = pcChatScrollMixins.mixins[0];
  const { mountedAction } = first;
  mountedAction();
});

onUnmounted(() => {
  const first = pcChatScrollMixins.mixins[0];
  const { destroyedAction } = first;
  destroyedAction();
});

return (_ctx: any,_cache: any) => {
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (msgItem, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: msgItem.id
            }, [
              (msgItem.role == 'user')
                ? (_openBlock(), _createBlock(MsgMine, {
                    key: 0,
                    msgObj: msgItem
                  }, null, 8, ["msgObj"]))
                : (msgItem.role == 'assistant')
                  ? (_openBlock(), _createBlock(MsgReply, {
                      key: 1,
                      msgIndex: index,
                      msgObj: msgItem
                    }, null, 8, ["msgIndex", "msgObj"]))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (isReplying.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "stop-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stopAbort) && _unref(stopAbort)(...args)))
            }, [
              _createVNode(_component_el_icon, { size: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CircleClose)
                ]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" 停止生成 "))
            ]))
          : _createCommentVNode("", true),
        _createVNode(ChatInputBar, { class: "input-bar" })
      ])
    ])
  ]))
}
}

})